import React, { useState } from "react";
import "./Header.css";

import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import { Link, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCartShopping,
  faHeart,
  faMagnifyingGlass,
  faUser,
} from "@fortawesome/free-solid-svg-icons";

function Header() {
  const location = useLocation();
  const [expanded, setExpanded] = useState(false); // state to control navbar toggle

  const handleNavClick = () => {
    setExpanded(false);
  };

  return (
    <>
      <section className="main_head">
 

        <div className="container-fluid p-0">
          <div className="container-md">
            <Navbar expand="lg" expanded={expanded} onToggle={setExpanded}>
              <Navbar.Brand href="#home">
                <div className="logodiv">
                  <Link to="/">
                    <img
                      src={
                        process.env.PUBLIC_URL + "/assets/images/logo/geecart_logo.png"
                      }
                      alt="Logo"
                      className="logo-img"
                    />
                  </Link>
                </div>
              </Navbar.Brand>
              <Navbar.Toggle aria-controls="basic-navbar-nav" />

              <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="">
                  <Nav.Link
                    as={Link}
                    to="/"
                    className={location.pathname === "/" ? "active" : ""}
                    onClick={handleNavClick}
                  >
                    Home
                  </Nav.Link>

                  <Nav.Link
                    as={Link}
                    to="/about-us"
                    className={
                      location.pathname === "/about-us" ? "active" : ""
                    }
                    onClick={handleNavClick}
                  >
                    About Us
                  </Nav.Link>

                  <Nav.Link
                    as={Link}
                    to="/contact-us"
                    className={
                      location.pathname === "/contact-us" ? "active" : ""
                    }
                    onClick={handleNavClick}
                  >
                    Contact Us
                  </Nav.Link>
                </Nav>
              </Navbar.Collapse>
            </Navbar>
          </div>
        </div>
      </section>
    </>
  );
}

export default Header;
